var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTime } from 'luxon';
import { useSearchParams } from '../useSearchParams';
export var useRedirectDateHandler = function (updateDateAction) {
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    return function (newDate) {
        var newDateTime = DateTime.fromISO(newDate);
        (newDateTime === null || newDateTime === void 0 ? void 0 : newDateTime.isValid) &&
            setSearchParams(__assign(__assign({}, Object.fromEntries(searchParams)), { date: newDateTime.toISODate() }), {
                replace: true
            });
        updateDateAction(newDateTime);
    };
};
